import React from 'react'
import { ContentIcon, Icon } from './styles'
import { SocialLabels } from 'src/types'

export function MapSocial({ icon, name, link }: SocialLabels) {
    return (
        <ContentIcon href={link} target={'_blank'}>
            <Icon src={icon} alt={name} />
        </ContentIcon>
    )
}
